import React, { useEffect, useMemo, useState } from 'react';
import { apiClient } from '../../../utils/axios';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from '@mui/material';

const BulkUploadTemplateSelector = ({ onSelect, category, subCategory }) => {
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const templateNameLabel = 'Template Name';

  useEffect(() => {
    apiClient
      .get(`/bulk-uploads/template`, { params: { category, subCategory } })
      .then((response) =>
        setTemplates(Array.isArray(response.data?.template_configs) ? response.data.template_configs : []),
      );
  }, [category, subCategory]);

  useEffect(() => {
    setSelectedTemplate(null);
  }, [category, subCategory]);

  const templateOptions = useMemo(
    () =>
      templates.map((item) => ({
        key: item.template_name,
        value: item.template_name,
        label: item.display_name ?? item.template_name,
      })),
    [templates],
  );

  const handleChange = (event, value) => {
    setSelectedTemplate(value);
    onSelect(value?.value);
  };

  return (
    <Autocomplete
      id="template-selector"
      options={templateOptions}
      getOptionLabel={(option) => option?.label ?? ''}
      isOptionEqualToValue={(option, value) => option?.value === value?.value}
      renderInput={(params) => <TextField {...params} label={templateNameLabel} />}
      onChange={handleChange}
      value={selectedTemplate}
    />
  );
};

export default BulkUploadTemplateSelector;
